import { MultiSelect, MultiSelectOption } from 'components/forms/multiselect/MultiSelect';
import { MultiSelectPopup } from 'components/forms/multiselect/MultiSelectPopup';
import { InfiniteScroll } from 'components/infinite_scroll/InfiniteScroll';
import { useSystemsInfiniteDataSource } from 'custom_hooks/data_hooks/data_source/systemsDataSource';
import { useDebounceCallback } from 'custom_hooks/useDebounceCallback';
import { useMemo } from 'react';

export type StaticSystemsMutliSelectProps = Readonly<{
    locationId: string;
    staticSystemsIds: MultiSelectOption<string>[];
    onChange: (staticSystemsIds: MultiSelectOption<string>[]) => void;
}>;

export function StaticSystemsMutliSelect({
    locationId,
    staticSystemsIds,
    onChange,
}: StaticSystemsMutliSelectProps) {
    const {
        results: systems,
        hasNext,
        isLoading,
        loadNext,
        filter,
        setFilter,
    } = useSystemsInfiniteDataSource({
        name: 'multi-select-systems',
        defaultFilter: { locationId, nameSearch: '', isCollectorDependentSystem: false },
        defaultSort: [{ field: 'Name', dir: 'asc' }],
    });

    const multiSelectSystems = useMemo(
        () => systems?.map((s) => ({ title: s.Name, value: s.Id })) ?? [],
        [systems],
    );

    const filterDebounce = useDebounceCallback(250, (value) => {
        setFilter({
            ...filter,
            nameSearch: value,
        });
    });

    return (
        <>
            <MultiSelectPopup
                label="Static System(s)"
                searchPlaceholder="Filter static systems"
                contentClassName="menu-max-height ml-10"
                popupClassName="modal-popup"
                searchable
                onFilterChange={filterDebounce}
            >
                <InfiniteScroll
                    enabled={hasNext ?? false}
                    isLoading={isLoading}
                    onLoadMore={loadNext}
                    className="f-14"
                    style={{ maxHeight: '30rem', minHeight: '5rem' }}
                >
                    <MultiSelect
                        options={multiSelectSystems}
                        selectedOptions={staticSystemsIds}
                        onChange={(event) => onChange(event.selected)}
                    />
                </InfiniteScroll>
            </MultiSelectPopup>
        </>
    );
}
